import options from "../constants/AuditContextOptions.json"

export function getAuditContextOptions() {
    return options
}